// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23_yo","name":"styles_name__go9-h","phone":"styles_phone__3p-HW"};